import { Header, Footer } from './components'
import {
  About,
  ErrorPage,
  Home,
  Poll,
  RockPaperScissors,
  SimpleStorage,
  TaskManage,
  TransferToken,
  SubtleFaces,
  TicTacToe,
  MoviePlot,
  Inscription,
  IPFSUploader,
  GethCommands,
  ValidEth,
  CountMyNFT,
  SplitPay,
} from './pages'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

const router = createBrowserRouter([
  { path: '/', element: <Home /> },
  {
    path: '/tokentransfer',
    element: <TransferToken />,
  },
  {
    path: '/simplestorage',
    element: <SimpleStorage />,
  },
  {
    path: '/taskmanage',
    element: <TaskManage />,
  },
  {
    path: '/poll',
    element: <Poll />,
  },
  {
    path: '/about',
    element: <About />,
  },
  {
    path: '/rps',
    element: <RockPaperScissors />,
  },
  {
    path: '/subtlefaces',
    element: <SubtleFaces />,
  },
  {
    path: '/tictactoe',
    element: <TicTacToe />,
  },
  {
    path: '/plotgen',
    element: <MoviePlot />,
  },
  {
    path: '/inscription',
    element: <Inscription />,
  },
  {
    path: '/ipfs-upload',
    element: <IPFSUploader />,
  },
  {
    path: '/geth-commands',
    element: <GethCommands />,
  },
  {
    path: '/valid-eth',
    element: <ValidEth />,
  },
  {
    path: '/count-my-nft',
    element: <CountMyNFT />,
  },
  {
    path: '/split-pay',
    element: <SplitPay />,
  },
  {
    path: '/*',
    element: <ErrorPage />,
  },
])

const queryClient = new QueryClient()

function App() {
  return (
    <div className="App">
      <Header />
      <QueryClientProvider client={queryClient}>
        <div className="MainContent">
          <RouterProvider router={router} />
        </div>
      </QueryClientProvider>
      <Footer />
    </div>
  )
}

export default App
